import { render } from "./Hasil.vue?vue&type=template&id=52d4dba2&scoped=true"
import script from "./Hasil.vue?vue&type=script&lang=js"
export * from "./Hasil.vue?vue&type=script&lang=js"

import "./Hasil.vue?vue&type=style&index=0&id=52d4dba2&lang=scss&scoped=true"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d4dba2"]])

export default __exports__